module.exports = __webpack_public_path__ + "img/recht-mang.d10d755d.svg";